import { COMPANY } from './company';
import { MANAGE_USERS } from './manageUsers';
import { USER } from './user';

export const SETTINGS = { COMPANY, USER, MANAGE_USERS };
